import { Wrench, AlertTriangle, IndianRupee, Calendar, StickyNote } from "lucide-react";

const REPAIR_TYPES = [
  "Frame Repair",
  "Lens Replacement",
  "Screw Fitting",
  "Nose Pad Change",
  "Temple Replacement",
  "Hinge Repair",
  "Full Service",
  "Polishing",
  "Realignment",
  "Other",
];
const REPAIR_STATUSES = ["Received", "In Progress", "Ready", "Delivered", "Cancelled"];

function Row({ cols = 3, children }) {
  const grid = { 2: "sm:grid-cols-2", 3: "sm:grid-cols-2 lg:grid-cols-3" }[cols];
  return <div className={`grid grid-cols-1 ${grid} gap-3`}>{children}</div>;
}
function Sel({ label, name, value, onChange, options }) {
  return (
    <div>
      <label className="text-xs font-semibold text-slate-700">{label}</label>
      <select
        name={name}
        value={value || ""}
        onChange={onChange}
        className="mt-1 w-full h-11 rounded-md border border-slate-300 bg-white px-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
      >
        <option value="">Select…</option>
        {options.map((o) => (
          <option key={o}>{o}</option>
        ))}
      </select>
    </div>
  );
}
function Txt({ label, name, value, onChange, type = "text", placeholder }) {
  return (
    <div>
      <label className="text-xs font-semibold text-slate-700">{label}</label>
      <input
        type={type}
        name={name}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder || label}
        className="mt-1 w-full h-11 rounded-md border border-slate-300 px-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
      />
    </div>
  );
}

export default function RepairFields({ data, onChange }) {
  return (
    <div className="rounded-2xl border border-amber-100 bg-amber-50/30 p-5 space-y-4">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 grid place-items-center shadow-sm">
          <Wrench size={18} className="text-white" />
        </div>
        <div>
          <h3 className="text-base font-bold text-slate-900">Spectacles Repair Ticket</h3>
          <p className="text-xs text-slate-500">Log the problem, parts needed, and delivery ETA</p>
        </div>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3">
        <Row cols={3}>
          <Sel label="Repair Type" name="repair_type" value={data.repair_type} onChange={onChange} options={REPAIR_TYPES} />
          <Sel label="Status" name="repair_status" value={data.repair_status} onChange={onChange} options={REPAIR_STATUSES} />
          <Txt label="Delivery Date" name="repair_delivery_date" value={data.repair_delivery_date} onChange={onChange} type="date" />
        </Row>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <label className="text-xs font-semibold text-slate-700 flex items-center gap-1.5">
          <AlertTriangle size={13} className="text-amber-600" /> Problem Description
        </label>
        <textarea
          rows={3}
          name="repair_problem"
          value={data.repair_problem || ""}
          onChange={onChange}
          placeholder="What is wrong with the spectacles? (visible cracks, loose screw, broken hinge…)"
          className="mt-1.5 w-full resize-none rounded-md border border-slate-300 p-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
        />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3">
        <div className="flex items-center gap-2 text-xs font-semibold text-slate-700">
          <IndianRupee size={13} className="text-amber-600" /> Parts & Cost
        </div>
        <Row cols={2}>
          <Txt label="Parts Needed" name="repair_parts" value={data.repair_parts} onChange={onChange} placeholder="e.g. Left temple, nose pads" />
          <Txt label="Estimated Cost (₹)" name="repair_cost" value={data.repair_cost} onChange={onChange} type="number" placeholder="0" />
        </Row>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <label className="text-xs font-semibold text-slate-700 flex items-center gap-1.5">
          <StickyNote size={13} className="text-amber-600" /> Repair Notes
        </label>
        <textarea
          rows={2}
          name="repair_notes"
          value={data.repair_notes || ""}
          onChange={onChange}
          placeholder="Follow-up instructions, warranty info, technician notes…"
          className="mt-1.5 w-full resize-none rounded-md border border-slate-300 p-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
        />
      </div>
    </div>
  );
}
